import { Menu, MenuItem, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LoadingButton } from "@mui/lab";
import { authState } from "src/store/auth";
import ConfirmPopup from "src/shared/components/confirmation-popup";
import { canManageRole } from "../../../add-edit-employee/constants";
import { useArchiveEmployeeMutation } from "src/api/employees/employees";

const TableActions = ({
  rowId,
  rowRole,
  accountType,
  fetchActiveUsers,
}: {
  rowId: string;
  rowRole: string;
  accountType: string;
  fetchActiveUsers: () => {};
}) => {
  const navigate = useNavigate();
  const setNotifications = useSetRecoilState(notificationsState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openPopup, setOpenPopup] = useState(false);
  const [auth] = useRecoilState(authState);
  const { permissions, user } = auth;
  const roleType = user?.roleType;

  const canManage = canManageRole(roleType, rowRole);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpenPopup = () => {
    setOpenPopup(true);
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  // Apis
  const { mutate: mutateArchive, isPending: isPendingArchive } =
    useArchiveEmployeeMutation();

  const handleArchive = () => {
    handleClose();
    mutateArchive(rowId, {
      onSuccess: () => {
        setNotifications((prev) => [
          ...prev,
          {
            type: "success",
            message: "The employee has been archived successfully!",
          },
        ]);
        handleClosePopup();
        fetchActiveUsers();
      },
      onError: (error) => {
        console.log({ error });
        const { message, response } = error;
        setNotifications((prev) => [
          ...prev,
          {
            type: "error",
            message:
              response?.data?.message ??
              message ??
              "Oops! Something went wrong.",
          },
        ]);
      },
    });
  };

  const handleNavigateToEditPage = () => {
    navigate(accountType === "regular" ? `/employees/active/${rowId}/edit` : `/employees/active/sunmi/${rowId}/edit`);
  };

  return (
    <Stack direction={"row"}>
      {(canManage || accountType === "sunmi") && permissions?.arsannEmployees.edit && (
        <>
          <LoadingButton
            variant="contained"
            color="tertiary"
            endIcon={<KeyboardArrowDownIcon />}
            onClick={handleClick}
            size="small"
            sx={{ fontSize: "12px", color: "#7E8299", fontWeight: 600 }}
          >
            Actions
          </LoadingButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={handleNavigateToEditPage}
              sx={{
                width: "90px",
                fontSize: "14px",
                color: "primary.main",
                p: "4px 15px",
              }}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={handleOpenPopup}
              sx={{ fontSize: "14px", p: "4px 15px" }}
            >
              Archive
            </MenuItem>
          </Menu>
        </>
      )}
      <ConfirmPopup
        open={openPopup}
        setOpen={setOpenPopup}
        handleClose={handleClosePopup}
        subtitle="This action will remove this employee from active list and add him to
        archive list"
        submitBtnLabel="Archive"
        onSave={handleArchive}
        isLoading={isPendingArchive}
      />
    </Stack>
  );
};
export default TableActions;
